import {
  statementCancelResponseSchema,
  statementDepositResponseSchema,
  statementSchema,
  type Statement,
  type StatementCancelResponse,
  type StatementDepositResponse,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function fetchStatements(): Promise<Statement[]> {
  return apiFetch('/api/statements', { schema: z.array(statementSchema) });
}

export function depositStatements(files: readonly File[]): Promise<StatementDepositResponse> {
  const form = new FormData();
  for (const file of files) form.append('files', file, file.name);
  return apiFetch('/api/statements', { method: 'POST', body: form, schema: statementDepositResponseSchema });
}

export function cancelStatement(id: number): Promise<StatementCancelResponse> {
  return apiFetch(`/api/statements/${id}`, { method: 'DELETE', schema: statementCancelResponseSchema });
}
